export default __webpack_public_path__ + "static/media/Quantico-Bold.6c65a614.ttf";